import React, { Component } from 'react';
import { connect } from 'react-redux';
import {InputText} from 'primereact/inputtext';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Link} from 'react-router-dom';
import {Button} from 'primereact/button';
import {Dropdown} from 'primereact/dropdown';

import {Toast} from 'primereact/toast';
import { DROPDOWN_CONFIG ,DATATABLE_CONFIG, USER_SUBMENU_ID } from '../../../shared/Config';
import { HASACCESS } from '../../../shared/utility';
import Messages from '../../../shared/UI/Messages/Messages';
import * as actions from '../../../store/actions/index';

const tableData = [
    {
       itemid: '1',
       itemname: 'Item 1',
       category: 'Category A', 
       currentstock: 100,
       AveragePurchasePrice: 10,
        totalAveragePurchasePrice: 1000
    },
    {
        itemid: '2',
        itemname: 'Item 2',
        category: 'Category B',
        currentstock: 200,
        AveragePurchasePrice: 15,
        totalAveragePurchasePrice: 3000
    },
    {
        itemid: '3',
        itemname: 'Item 3',
        category: 'Category C',
        currentstock: 300,
        AveragePurchasePrice: 20,
        totalAveragePurchasePrice: 6000
    },
    {
        itemid: '4',
        itemname: 'Item 4',
        category: 'Category D',
        currentstock: 400,
        AveragePurchasePrice: 25,
        totalAveragePurchasePrice: 10000
    },

]

class CurrentstockReport extends Component {
    state = {
        selectedItems : []
    }
    
   
    actionTemplate = (rowData) => {

            return <div className="actionCenter">
                {(this.getAccess!==undefined && this.getAccess.editAccess!== false) &&
                    <Link to={"/user/edit/"+rowData.userId}><Button type="button" icon="pi pi-pencil" className="p-button-info" ></Button></Link>
                }
                {(this.getAccess!==undefined && this.getAccess.viewAccess!== false) &&
                    <Link to={"/user/view/"+rowData.userId}><Button type="button" icon="pi pi-eye" className="p-button-secondary" ></Button></Link>
                }
            </div>;
    }

    delete= () => {

        if(this.state.selectedItems.length > 0){
            const updatedValue = this.state.selectedItems.map( value => {
                return { DeleteID : value.userId};
            })
            this.props.dynamicDeleteProcess('user',updatedValue,'GeUsers');
        }
        else{
            this.growl.show({severity: 'error', summary: null, detail: 'Please select checkbox'});
        }

    }

    statusRender = (rowData) => {
        let status = <Button type="button" label="In Active" className="p-button-danger p-button-rounded" ></Button>
        if(rowData.isActive === true || rowData.isActive === null){
            status = <Button type="button" label="Active" className="p-button-success p-button-rounded" ></Button>
        }
        return <div className="actionCenter">
                    {status}
               </div>;
    }

    componentDidMount(){        
        this.getAccess = HASACCESS(USER_SUBMENU_ID);
        this.props.getMasterTableList('GeUsers');    
    }
  
    render() {   

        if(this.getAccess!==undefined && this.getAccess.viewAccess === false){
            this.props.history.push('/dashboard');
        }

        const header = (
            <div style={{'textAlign':'right'}}>
                <InputText type="search" onInput={(e) => this.setState({globalFilter: e.target.value})} placeholder="Search..." />
            </div>
        );

        // let tableData = [];

 
        // if(this.props.tableLists.usersList!==undefined) {
        //     tableData = this.props.tableLists.usersList;
        // }


        return (
            <div className="p-grid padding">
                { this.props.loading && <div className="page-loader"></div>}
                { this.props.error !== null && <Messages type="error" message={this.props.error}/>}
                { this.props.success !== null && <Messages type="success" message={this.props.success}/>}
                <Toast ref={(el) => this.growl = el} />
               <div className="p-col-12">
                    <div className="card card-w-title" style={{position:'relative'}}>
                        <h1>Current Stock Report</h1>
               
                        <div className="p-grid">
                        <div className="p-col-12 p-md-3 p-lg-3 p-d-flex p-flex-column p-gap-2">
                            <label className="label">Raw Material </label>
                            <InputText placeholder="Raw Material" className="p-col-12" name="Rawmaterial" />
                        </div>

                        <div className="p-col-12 p-md-3 p-lg-3 p-d-flex p-flex-column p-gap-2">
                            <label className="label">Category</label>
                            <Dropdown
                            placeholder="Category"
                            name="Category"
                            options={[
                                { label: 'Select Category', value: null },
                                { label: 'Category 1', value: 'cat1' },
                                { label: 'Category 2', value: 'cat2' },
                            ]}
                            value={this.state.category || null}
                            filter
                            autoWidth
                            className="p-col-12"
                            {...DROPDOWN_CONFIG}
                            />
                        </div>

                        <div className="p-col-12 p-md-3 p-lg-3 p-d-flex p-flex-column p-gap-2">
                            <label className="label">Stock Level </label>
                            <Dropdown
                            placeholder="Stock Level"
                            name="stocklevel"
                            options={[
                                { label: 'Select Stock Level', value: null },
                                { label: 'Low', value: 'low' },
                                { label: 'Medium', value: 'medium' },
                                { label: 'High', value: 'high' },
                            ]}
                            value={this.state.stockLevel || null}
                            filter
                            autoWidth
                            className="p-col-12"
                            {...DROPDOWN_CONFIG}
                            />
                        </div>

                       <div className="p-col-12 p-md-3 p-lg-3 p-d-flex p-ai-end p-jc-start p-gap-2">
                            <Button
                                label="Search"
                                // icon="pi pi-search"
                                className="p-button-primary"
                                onClick={this.handleSearch}
                            />
                            <Button
                                label="Show All"
                                // icon="pi pi-list"
                                className="p-button-secondary p-ml-2"
                                onClick={this.handleShowAll}
                            />
                        </div>                   
                           {/* Export button — pushed to far right */}
                            <div className="p-col-12 p-d-flex p-jc-end p-ai-end">
                                <Button
                                label="Export as Excel"
                                className="p-button-warning"
                                onClick={this.handleExportExcel}
                                />
                            </div>
                                {/* <div className="p-col-12 p-lg-12">
                                <div className="mt1">
                                {(this.getAccess!==undefined && this.getAccess.addAccess!== false) && 
                                 <Link to="/current-stock-report/add/new"><Button style={{float: 'right'}} label="Add Current Stock" className="ml1"  icon="pi pi-plus"  /></Link>
                                }
                                {(this.getAccess!==undefined && this.getAccess.deleteAccess!== false) && 
                                 <Button  style={{float: 'right'}} onClick={this.delete} label="Delete" icon="pi pi-trash"  className="p-button-danger"/>
                                }

                                </div>                                
                            </div> */}
                      
                                                    
                        <div className="p-col-12" style={{marginTop:'2em'}}>
                 
                        <DataTable value={tableData} 
                         selection={this.state.selectedItems} onSelectionChange={e => this.setState({selectedItems: e.value})}
                          globalFilter={this.state.globalFilter} header={header} {...DATATABLE_CONFIG} >
                                <Column selectionMode="multiple" style={{width:'3em'}}/>
                                <Column field="category" header="Category" sortable={true} />
                                <Column field="itemname" header="Item"  />
                                <Column field="currentstock" header="Current Stock"  />
                                <Column field="AveragePurchasePrice" header="Average Purchase price"  />
                                <Column field="totalAveragePurchasePrice" header="Total Value (current stock * average purchase price)"  />
                            </DataTable>
                        </div>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}
const mapStateToProps = state => {
    return{
        loggedUserDetail : state.auth.userObject,
        loading : state.master.loading,
        error : state.master.error,
        success: state.master.success,
        tableLists : state.master.tableLists
    }
}
  
const mapDispatchToProps = dispatch => {
    return{
        dynamicDeleteProcess: (model,data,func) => dispatch(actions.dynamicDeleteProcess(model,data,func)),
        getMasterTableList: (table) => dispatch(actions.getMasterTableList(table)),
    }
}
  
export default connect(mapStateToProps,mapDispatchToProps)(CurrentstockReport);


